import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Drawer, Box} from 'views/components';

import NavbarLogo from './navbar_top/NavbarLogo';
import NavbarServices from './navbar_services/NavbarServices';
import NavbarUser from './navbar_bottom/NavbarUser';


const NavBar = (props) => {
  const services = props.services;

  return (
    <Drawer
      sx={{
        'width': 312,
        'flexShrink': 0,
        '& .MuiDrawer-paper': {
          width: 312,
          boxSizing: 'border-box',
        },
      }}
      PaperProps={{
        sx: {
          backgroundColor: 'navbar.main',
        },
      }}
      open={true}
      variant="permanent"
      anchor="left"
    >
      <Box sx={{
        pt: 3,
        pb: 2,
        px: 4,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
      >
        <NavbarLogo />
      </Box>
      <Box
        sx={{
          px: 4,
        }}
      >
        <NavbarServices
          services={Object.values(services)}
        />
      </Box>
      <Box sx={{
        mt: 'auto',
      }}
      >
        <Box sx={{
          px: 4,
          pb: 4,
        }}
        >
          <NavbarUser />
        </Box>
      </Box>
    </Drawer>
  );
};

NavBar.propTypes = {
  services: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavBar));
